import clsx from 'clsx';
import { ReactNode } from 'react';

import { Loader, TLoaderVariant } from '../loading/components/loader';

interface LoadingLayoutProps {
  children?: ReactNode;
  classes?: string;
  loader?: TLoaderVariant;
  loading: boolean;
  overlay?: boolean;
  message?: string;
}

export const LoadingLayout = ({
  children,
  classes,
  loader = 'stack',
  loading,
  overlay = false,
  message = 'Loading'
}: LoadingLayoutProps) => (
  <div className={clsx('relative', { 'w-full h-full': overlay }, classes)}>
    {loading && (
      <div
        className={clsx('absolute inset-0 flex justify-center items-center', {
          'bg-onyx/85 backdrop-blur-sm z-100 animate-fade-in': overlay
        })}
      >
        {overlay ? (
          <div className="flex flex-col items-center gap-5">
            <div className="relative flex items-center justify-center w-28 h-28">
              <span
                aria-hidden
                className="absolute inset-0 rounded-full bg-mantis/20 animate-glow-wave"
                style={{ animationDelay: '0ms' }}
              />
              <span
                aria-hidden
                className="absolute inset-0 rounded-full bg-mantis/15 animate-glow-wave"
                style={{ animationDelay: '800ms' }}
              />
              <span
                aria-hidden
                className="absolute inset-0 rounded-full bg-mantis/10 animate-glow-wave"
                style={{ animationDelay: '1600ms' }}
              />

              <div className="relative z-10 flex items-center justify-center w-20 h-20 rounded-full bg-onyx/70 ring-1 ring-mantis/30 shadow-[inset_0_0_20px_rgba(135,192,71,0.15)]">
                <div className="animate-breathe">
                  <Loader variant={loader} />
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center gap-2">
              <span className="block w-12 h-px bg-gradient-to-r from-transparent via-mantis/50 to-transparent" />
              <p className="text-sm text-mountain-mist font-sans tracking-wide">{message}</p>
            </div>
          </div>
        ) : (
          <Loader variant={loader} />
        )}
      </div>
    )}

    {children}
  </div>
);
